import User from 'core/models/user';

export const getUserLabel = (user: User, t: any): string =>
    `${user.civility ? t(`common.civility.enum.${user.civility}`) : ''} ${user.firstName}${
        user.firstName && user.lastName ? ' ' : ''
    }${user.lastName}`;
